import { timeUtils } from '@instinet-analytics/core-lib';
import { DateTime } from 'luxon';

const { roundToDays } = timeUtils;

export const oneDay = 86400000;
export const oneWeek = oneDay * 7;

export const today = () => roundToDays(new Date().getTime());

export const isFriday = (date: number | undefined) =>
    !!(date && DateTime.fromMillis(date).weekday === 5);
